/** Mirrors the backend enum kilobyte.zookeeper.model.enums.ReferralType. */
export const ANIMAL = "ANIMAL";
export const MATERIAL = "MATERIAL";
